import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { 
  Box, 
  Container, 
  Typography, 
  TextField, 
  Button, 
  Checkbox, 
  FormControlLabel, 
  Grid, 
  Paper, 
  Divider, 
  CircularProgress 
} from '@mui/material';
import ProductImageSlider from './ProductImageSlider';
import img1 from '../assets/products/1.jpg';
import img2 from '../assets/products/2.jpg';
import img3 from '../assets/products/3.jpg';
import img4 from '../assets/products/4.jpg';
import img5 from '../assets/products/Mockup.jpg';

const productImages = [img1, img2, img3, img4, img5];

function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}

export default function OrderForm() {
  const [formData, setFormData] = useState({
    mobile_number: '',
    full_name: '',
    complete_address: '',
    landmark: '',
    pincode: '',
    city: '',
    state: '',
    alternate_mobile_number: '',
    email_id: '',
    billing_same_as_delivery: true,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadScript('https://checkout.razorpay.com/v1/checkout.js');
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  async function displayRazorpay(e) {
    e.preventDefault();
    setLoading(true);

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
    const ORDERS_ENDPOINT = `${API_BASE_URL}/api/orders`;
    const VERIFY_ENDPOINT = `${API_BASE_URL}/api/payments/verify`;

    try {
      const { data } = await axios.post(ORDERS_ENDPOINT, formData);

      const options = {
        key: data.key,
        amount: data.amount,
        currency: data.currency,
        name: data.name,
        description: data.description,
        order_id: data.razorpay_order_id,
        handler: async function (response) {
          try {
            const { data: verifyData } = await axios.post(VERIFY_ENDPOINT, {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            });

            if (verifyData.status === 'success') {
              // Redirect to success page with order ID
              window.location.href = `/order/success?order_id=${verifyData.order_id}`;
            } else {
              // Redirect to failure page with error message
              window.location.href = `/order/failed?error=${encodeURIComponent('Payment verification failed. Please contact support.')}`;
            }
          } catch (error) {
            console.error('Verification Error:', error);
            // Redirect to failure page with error message
            window.location.href = `/order/failed?error=${encodeURIComponent('An error occurred during payment verification.')}`;
          }
        },
        modal: {
          ondismiss: function() {
            // Handle when user closes the payment modal without completing payment
            window.location.href = '/order/failed?error=' + encodeURIComponent('Payment was cancelled. Your card has not been charged.');
          }
        },
        prefill: data.prefill,
        theme: {
          color: '#0a716e' // Using your brand color
        }
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();

    } catch (error) {
      console.error('Order Error:', error);
      // Redirect to failure page with error message
      const errorMessage = error.response?.data?.message || 'An error occurred while creating the order. Please try again.';
      window.location.href = `/order/failed?error=${encodeURIComponent(errorMessage)}`;
    }
    setLoading(false);
  }

  return (
    <Container sx={{ maxWidth: '1200px', mx: 'auto', py: 8 }}>
      <Paper elevation={3} sx={{ p: { xs: 4, md: 6 }, borderRadius: 2, boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: '400', mb: 4, textAlign: 'left' }}>
        Your acne’s on the exit lane—keep going!
        </Typography>
        
        <Grid container spacing={4}>
          {/* Left Column - Product Details */}
          <Grid item xs={12} md={5}>
            <Box sx={{ mb: 2 }}>
              <Paper elevation={2} sx={{ p: 2, borderRadius: 2, mb: 3, boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>
                <Box sx={{ width: '100%', maxWidth: 400, mx: 'auto' }}>
                  <ProductImageSlider images={productImages} />
                </Box>
                <Box sx={{ mt: 3, textAlign: 'center' }}>
                  <Typography variant="h6" sx={{ fontWeight: 500, mb: 1 }}>
                    Ixoria Anti-Acne Face Mask
                  </Typography>
                  {/* <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, alignItems: 'center', mb: 1 }}>
                    <Typography variant="body1" sx={{ textDecoration: 'line-through', color: 'text.secondary' }}>
                      ₹1,100
                    </Typography>
                    <Typography variant="h6" color="primary" sx={{ fontWeight: 600 }}>
                      ₹999
                    </Typography>
                    <Typography variant="body2" color="error" sx={{ fontWeight: 500 }}>
                      9% OFF
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    (Inclusive of all taxes)
                  </Typography> */}
                </Box>
              </Paper>
              <Paper sx={{ p: 3, borderRadius: 2, boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>
                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                  Order Summary
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography variant="body2">Subtotal</Typography>
                  <Typography variant="body2">₹999</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography variant="body2">Shipping</Typography>
                  <Typography variant="body2">FREE</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Total</Typography>
                  <Box>
                    <Typography variant="body2" sx={{ textDecoration: 'line-through', color: 'text.secondary', textAlign: 'right' }}>
                      ₹1,100
                    </Typography>
                    <Typography variant="h6" color="primary" sx={{ fontWeight: 700 }}>
                      ₹999
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Grid>

          {/* Right Column - Shipping Form */}
          <Grid item xs={12} md={7}>
            <Paper elevation={0} sx={{ p: 3, borderRadius: 2, boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>
              <Typography variant="h6" sx={{ mb: 3, fontWeight: 500 }}>Shipping Details</Typography>
              <form onSubmit={displayRazorpay}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      fullWidth
                      id="mobile_number"
                      name="mobile_number"
                      label="Mobile Number"
                      value={formData.mobile_number}
                      onChange={handleChange}
                      size="small"
                      margin="normal"
                      InputProps={{
                        startAdornment: <Box sx={{ mr: 1 }}>+91</Box>,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      fullWidth
                      id="full_name"
                      name="full_name"
                      label="Full Name"
                      value={formData.full_name}
                      onChange={handleChange}
                      size="small"
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      required
                      fullWidth
                      id="complete_address"
                      name="complete_address"
                      label="Complete Address"
                      multiline
                      rows={5}
                      value={formData.complete_address}
                      onChange={handleChange}
                      size="small"
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      id="landmark"
                      name="landmark"
                      label="Landmark (Optional)"
                      value={formData.landmark}
                      onChange={handleChange}
                      size="small"
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      fullWidth
                      id="pincode"
                      name="pincode"
                      label="Pincode"
                      value={formData.pincode}
                      onChange={handleChange}
                      size="small"
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      fullWidth
                      id="city"
                      name="city"
                      label="City"
                      value={formData.city}
                      onChange={handleChange}
                      size="small"
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      fullWidth
                      id="state"
                      name="state"
                      label="State"
                      value={formData.state}
                      onChange={handleChange}
                      size="small"
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      id="alternate_mobile_number"
                      name="alternate_mobile_number"
                      label="Alternate Mobile Number (Optional)"
                      value={formData.alternate_mobile_number}
                      onChange={handleChange}
                      size="small"
                      margin="normal"
                      InputProps={{
                        startAdornment: <Box sx={{ mr: 1 }}>+91</Box>,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      id="email_id"
                      name="email_id"
                      label="Email Id (Optional)"
                      type="email"
                      value={formData.email_id}
                      onChange={handleChange}
                      size="small"
                      margin="normal"
                    />
                  </Grid>
                  {/* <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox 
                          checked={formData.billing_same_as_delivery} 
                          onChange={handleChange} 
                          name="billing_same_as_delivery" 
                          color="primary" 
                        />
                      }
                      label="Billing Details are same as Delivery Details"
                    />
                  </Grid> */}
                  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Box sx={{ position: 'relative' }}>
                      <Button 
                        type="submit" 
                        variant="contained" 
                        color="primary" 
                        size="large" 
                        disabled={loading}
                        sx={{ px: 8, py: 1.5, borderRadius: 999, mt: 7 }}
                      >
                        Proceed to Payment
                      </Button>
                      {loading && (
                        <CircularProgress
                          size={24}
                          sx={{
                            color: 'primary.main',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            marginTop: '-12px',
                            marginLeft: '-12px',
                          }}
                        />
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}
